import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import "./styles/theme.css";
import { aplicarSsoDoHash, ehEmbutido, seguirTemaDoErp } from "./lib/sso";

aplicarSsoDoHash();
if (ehEmbutido()) document.body.classList.add("embutido");
seguirTemaDoErp();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
